exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd]{min-height:100vh;width:100%;position:relative;overflow:hidden;background:#F0F2F5}.fixed-header+.app-main[data-v-078753dd]{padding-top:0.64rem}.hasTagsView .app-main[data-v-078753dd]{min-height:calc(100vh - 84px)}.hasTagsView .fixed-header+.app-main[data-v-078753dd]{padding-top:84px}\n", ""]);

// exports
